import { EventEmitter } from 'events';
import { setEventEmitter as setEventEmitterDiagram } from '@process-advisor/process-miner/processMiner/processMiner';

export function setEventEmitter  ()   {
    const eventEmitter: EventEmitter = new EventEmitter();
    eventEmitter.setMaxListeners(100);
    setEventEmitterDiagram(eventEmitter)
}
